import {TriggerSpec} from "../models/remoteConstants.model";

// A fresh TriggerSpec of the given kind with its kind-specific fields at their
// defaults. Shared by the Add Reward menu and the card's Trigger dropdown so a
// reward created as EveryNTurns and one switched to it start out identical.
export function defaultTriggerSpec(kind: TriggerSpec['kind']): TriggerSpec {
    switch (kind) {
        case 'OnPlace': return {kind};
        case 'OnUpgrade': return {kind};
        case 'EveryNTurns': return {kind, cadence: 1, firstTriggerDelay: 0};
        case 'PerAdjacent': return {kind, adjacentTo: ''};
        case 'PerAdjacentOnce': return {kind, adjacentTo: ''};
        case 'TilesExplored': return {kind, cloudCount: 1};
        case 'FullTurnOccupied': return {kind};
        case 'BuiltOnTile': return {kind, containing: '', cadence: 1, firstTriggerDelay: 0};
    }
}

// One line per trigger for the Add Reward menu — the kind names alone don't
// distinguish the close pairs (OnPlace/OnUpgrade, PerAdjacent/PerAdjacentOnce).
export const TRIGGER_DESCRIPTIONS: Record<TriggerSpec['kind'], string> = {
    OnPlace: 'Once, when the building is placed',
    OnUpgrade: 'Once, when upgraded from another building',
    EveryNTurns: 'Every N turns while the building stands',
    PerAdjacent: 'Every turn, for each adjacent match',
    PerAdjacentOnce: 'Once per adjacent match, permanently',
    TilesExplored: 'For every N tiles explored',
    FullTurnOccupied: 'At turn end, if fully occupied',
    BuiltOnTile: 'Every N turns, if built on a matching tile',
};
